import { Vue, Component, Prop } from 'vue-property-decorator'
import ImageElement from '~/components/element/ImageElement'
import Img from '~/types/api/Img'
import Product from '~/types/api/Product'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'

@Component
export default class ProductSmall extends Vue {
  @Prop({ required: true, type: Object })
  product!: Product;

  get link () {
    if (this.product.path) {
      return `${this.product.path}/${this.product.seoUrl}/`
    } else {
      const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
      const sections = this.product.sectionId
      return helper.getProductLink(sections?.length ? sections[0] : s(this.$store).categoryPage.category.id, this.product.seoUrl ?? this.product.id)
    }
  }

  get defaultImg (): Img {
    return {
      d: require('~/assets/image/pill.png'),
      t: require('~/assets/image/pill.png'),
      m: require('~/assets/image/pill.png')
    }
  }

  render () {
    return (
      <nuxt-link class="product-small" to={this.link}>
        {this.product.img &&
          <div class="product-small__image">
            <ImageElement props={{
              img: Object.keys(this.product.img).length !== 0 ? this.product.img : this.defaultImg,
              title: this.product.title,
              alt: this.product.title
            }} />
          </div>
        }
        <div class="product-small__info">
          <div class="product-small__name">
            {this.product.title}
          </div>
          {this.product.mnn &&
            <div class="product-small__mnn">
              MNN {this.product.mnn}
            </div>
          }
        </div>
      </nuxt-link>
    )
  }
}
